import React, { useReducer, useEffect, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography as MUITypography,
  LinearProgress,
  Chip,
  Badge,
} from "@mui/material";
import * as moment from "moment";
import Typography from "../Typography";
import AvatarName from "../AvatarName";
import PhoneIcon from "@mui/icons-material/Phone";
import ChatIcon from "@mui/icons-material/Chat";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import RemoveIcon from "@mui/icons-material/Remove";
import PeopleIcon from "@mui/icons-material/People";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Pie, ResponsiveContainer, Tooltip, Cell } from "recharts";
import PieChart from "../D3/PieChart";
import { getPieChartColor } from "../D3/PieChart/colors";
import api from "../../api";
import defaultReducer from "../../utils/defaultReducer";
import { getSession } from "../../auth";

import "./styles.css";
import { platformIcon } from "../Report/NewDetailedRegister/contact_graph_exception";

let interval = 0;

const user = getSession();
const enterprise = user?.profile.enterprise;
const enterpriseId = enterprise?.id;
const userId = user?.id;
const agentId = user?.profile?.agent_id;
const has_voice = enterprise?.has_voice || enterprise?.whatsapp_calling;
const user_has_voice = user?.profile?.agent?.preferred_interface || user?.profile?.agent?.external_username;
const extensionUser = (() => {
  if (has_voice) {
    if (user?.profile?.agent?.external_username) {
      return user.profile.agent.external_username.split("_")[1] || "";
    } else if (user?.profile.agent?.preferred_interface) {
      return user?.profile.agent?.preferred_interface.split("_")[1] || "";
    }
  }
  return "";
})();

const agentUser = (() => {
  if (user?.profile?.instantvoice_agent_code) {
    return user.profile.instantvoice_agent_code;
  } else if (user?.profile?.agent?.user) {
    return user?.profile?.agent?.user.split("_")[1] || "";
  }
  return "";
})();

const mockdata = [
  { name: "WhatsApp", value: 12 },
  { name: "Instagram", value: 9 },
  { name: "Telefone", value: 3 },
  { name: "E-mail", value: 6 },
];

const UserInfo = ({
  name,
  agentStatus,
  enterpriseName,
  loginTime,
  agentUser,
  extensionUser,
  userHasVoice,
}) => {
  return (
    <Grid container className="agentoverview-grid">
      <Grid item lg={6} md={6} sm={6} xs={12} className="agentoverview-item">
        <Box className="userinfo-usercard">
          <Box id="userinfo-box-1">
            <IconButton size="large" className="icon-button-avatar">
              <AvatarName
                name={name}
                // handleClick={() => {
                // }}
                size="big"
              />
              {agentStatus == "LOGIN" && (
                <Box className="big-circle login" title="Agente Logado"></Box>
              )}
              {agentStatus == "LOGOFF" && (
                <Box
                  className="big-circle logoff"
                  title="Agente Deslogado"
                ></Box>
              )}
              {agentStatus == "PAUSE" && (
                <Box className="big-circle pause" title="Agente Pausado"></Box>
              )}
            </IconButton>

            <Box className="userinfo-userdata">
              <Box className="fontSize-title userinfo-name-enterprise">
                <Typography
                  align="center"
                  text={name}
                  color="darkGray"
                  fontWeight="500"
                  variant="h5"
                />
                <Typography
                  align="center"
                  text={`[${enterpriseName}]`}
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
              </Box>
              <Typography
                align="left"
                text={`Login: ${loginTime}`}
                color="darkGray"
                fontWeight="500"
                variant="subtitle1"
              />
            </Box>
          </Box>
          {/* userinfo-box-1 */}
        </Box>
        {/* userinfo-usercard */}
      </Grid>
      <Grid item lg={6} md={6} sm={6} xs={12} className="agentoverview-item">
        <Box className="userinfo-extension">
          <Box id="userinfo-box-1">
            {userHasVoice && (
              <>
              <PhoneIcon fontSize="large" color="success" />
              <Box className="userinfo-extension">
                <Typography
                  align="center"
                  text={`Ramal: ${extensionUser}`}
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
                <Typography
                  align="center"
                  text={`Operador: ${agentUser}`}
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
              </Box>
              </>
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const renderCustomizedLabel = (
  { cx, cy, midAngle, innerRadius, outerRadius, percent, index },
  source,
  vx,
  vy,
  renderValue = null
) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 1.25;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="black"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {source[index][vx || "name"]}:{" "}
      {renderValue
        ? renderValue(vy, source[index])
        : source[index][vy || "count"]}
    </text>
  );
};

const renderValue = (row) => {
  return `${row.name}: ${row.value}`;
};
const ContactGraph = ({ data, vx, vy }) => {
  const [hoveredSegment, setHoveredSegment] = React.useState(null);

  if (!data || data.length === 0) {
    return (
      <Box className='agentqueues-no-contact-centralize'>
        <Typography
          align="center"
          text="Nenhum contato finalizado hoje."
          color="darkGray"
          fontWeight="500"
          variant="h6"
        />
      </Box>
    );
  }

  // Calculate total and percentages for better UX
  const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
  const dataWithPercentages = data.map(item => ({
    ...item,
    percentage: total > 0 ? Math.round((item.value / total) * 100) : 0
  }));

  return (
    <Box className="contact-graph-container">
      {/* Enhanced Legend */}
      <Box className="contact-graph-legend">
        {dataWithPercentages.map((item, index) => (
          <Box
            key={index}
            className={`legend-item ${hoveredSegment === item.name ? 'legend-item-hovered' : ''}`}
            onMouseEnter={() => setHoveredSegment(item.name)}
            onMouseLeave={() => setHoveredSegment(null)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              padding: '4px 6px',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              backgroundColor: hoveredSegment === item.name ? '#f0f4ff' : 'transparent',
              border: hoveredSegment === item.name ? '1px solid #2196f3' : '1px solid transparent',
              '&:hover': {
                backgroundColor: '#f0f4ff',
                transform: 'scale(1.01)',
              }
            }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: getPieChartColor(item.name) || '#ccc',
                border: hoveredSegment === item.name ? '1px solid #fff' : 'none',
                boxShadow: hoveredSegment === item.name ? '0 0 4px rgba(33, 150, 243, 0.4)' : 'none',
              }}
            />
            {item.icon && (
              <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 14 }}>
                {item.icon}
              </Box>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <MUITypography
                variant="body2"
                sx={{
                  fontWeight: hoveredSegment === item.name ? 600 : 500,
                  color: hoveredSegment === item.name ? '#1565c0' : '#333',
                  fontSize: '0.75rem',
                  lineHeight: 1.2
                }}
              >
                {item.name}
              </MUITypography>
              <MUITypography
                variant="caption"
                sx={{
                  color: '#666',
                  fontSize: '0.65rem',
                  fontWeight: hoveredSegment === item.name ? 600 : 400,
                  lineHeight: 1
                }}
              >
                {item.value} ({item.percentage}%)
              </MUITypography>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Chart Container */}
      <Box className="contact-graph-chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart 
            label='' 
            data={dataWithPercentages} 
            type={'number'} 
            legend={false}
            showLegend={false}
            hoveredSegment={hoveredSegment}
            onSegmentHover={setHoveredSegment}
          />
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const getStatIcon = (statName) => {
  const name = statName.toLowerCase();
  if (name.includes('fila') || name.includes('queue') || name.includes('aguardando')) {
    return <PeopleIcon sx={{ fontSize: 16, color: '#2196f3' }} />;
  }
  if (name.includes('tempo') || name.includes('time') || name.includes('duração')) {
    return <AccessTimeIcon sx={{ fontSize: 16, color: '#ff9800' }} />;
  }
  if (name.includes('finalizado') || name.includes('concluído') || name.includes('completed')) {
    return <CheckCircleIcon sx={{ fontSize: 16, color: '#4caf50' }} />;
  }
  if (name.includes('transferido') || name.includes('transfer')) {
    return <TrendingUpIcon sx={{ fontSize: 16, color: '#9c27b0' }} />;
  }
  return <RemoveIcon sx={{ fontSize: 16, color: '#757575' }} />;
};

const StatCard = ({ statName, statValue, isLarge = false }) => {
  const getProgressValue = (value) => {
    const numValue = parseInt(value) || 0;
    return Math.min(numValue * 10, 100); // Normalize to 100 max for visual effect
  };

  const getValueColor = (value) => {
    const numValue = parseInt(value) || 0;
    if (numValue === 0) return '#e0e0e0';
    if (numValue <= 3) return '#4caf50';
    if (numValue <= 7) return '#ff9800';
    return '#f44336';
  };

  return (
    <Card 
      className={`stat-card ${isLarge ? 'stat-card-large' : ''}`}
      sx={{ 
        minHeight: isLarge ? 60 : 45,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        }
      }}
    >
      <CardContent className="stat-card-content">
        <Box className="stat-card-header">
          {getStatIcon(statName)}
          <MUITypography 
            variant="body2" 
            className="stat-name"
            sx={{ 
              fontWeight: 600,
              color: '#333',
              fontSize: isLarge ? '0.75rem' : '0.7rem'
            }}
          >
            {statName}
          </MUITypography>
        </Box>
        
        <Box className="stat-value-container">
          <MUITypography 
            variant={isLarge ? "h6" : "body1"} 
            className="stat-value"
            sx={{ 
              fontWeight: 700,
              color: getValueColor(statValue),
              fontSize: isLarge ? '1.1rem' : '1rem'
            }}
          >
            {statValue}
          </MUITypography>
          
          {parseInt(statValue) > 0 && (
            <LinearProgress
              variant="determinate"
              value={getProgressValue(statValue)}
              sx={{
                height: 2,
                borderRadius: 1,
                backgroundColor: '#f0f0f0',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: getValueColor(statValue),
                  borderRadius: 1,
                }
              }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

const AgentQueue = ({ name, notification, stats }) => {
  const getTotalInQueue = () => {
    const queueStat = stats.find(s => 
      s.name.toLowerCase().includes('fila') || 
      s.name.toLowerCase().includes('aguardando') ||
      s.name.toLowerCase().includes('queue')
    );
    return queueStat ? parseInt(queueStat.value) || 0 : 0;
  };

  const getNotificationColor = (notification) => {
    if (!notification) return 'default';
    const notif = notification.toLowerCase();
    if (notif.includes('alta') || notif.includes('urgent')) return 'error';
    if (notif.includes('média') || notif.includes('medium')) return 'warning';
    if (notif.includes('baixa') || notif.includes('low')) return 'success';
    return 'info';
  };

  const totalInQueue = getTotalInQueue();

  return (
    <Card className="agent-queue-card" sx={{ 
      mb: 2,
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: '0 6px 25px rgba(0,0,0,0.1)',
      }
    }}>
      <CardContent className="agent-queue-content">
        <Box className="agent-queue-header">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MUITypography
              variant="h6"
              sx={{ 
                fontWeight: 600,
                color: '#333',
                fontSize: '0.95rem'
              }}
            >
              {name}
            </MUITypography>
            {totalInQueue > 0 && (
              <Badge 
                badgeContent={totalInQueue} 
                color={totalInQueue > 5 ? 'error' : totalInQueue > 2 ? 'warning' : 'success'}
                sx={{
                  '& .MuiBadge-badge': {
                    fontSize: '0.6rem',
                    fontWeight: 600,
                    minWidth: 16,
                    height: 16,
                  }
                }}
              >
                <PeopleIcon sx={{ fontSize: 16, color: '#666' }} />
              </Badge>
            )}
          </Box>
          
          {notification && (
            <Chip
              label={notification}
              color={getNotificationColor(notification)}
              size="small"
              sx={{ 
                fontSize: '0.75rem',
                fontWeight: 500,
                '&.MuiChip-colorError': { backgroundColor: '#ffebee', color: '#c62828' },
                '&.MuiChip-colorWarning': { backgroundColor: '#fff8e1', color: '#e65100' },
                '&.MuiChip-colorSuccess': { backgroundColor: '#e8f5e8', color: '#2e7d32' },
                '&.MuiChip-colorInfo': { backgroundColor: '#e3f2fd', color: '#1565c0' },
              }}
            />
          )}
        </Box>
        
        <Box className="agent-queue-stats">
          {stats.map((s, idx) => (
            <StatCard 
              key={idx} 
              statName={s.name} 
              statValue={s.value}
              isLarge={idx === 0} // Make first stat larger
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

const AgentQueues = ({ media, queues }) => {
  const getMediaIcon = (media) => {
    if (media.toLowerCase().includes('chat')) {
      return <ChatIcon sx={{ fontSize: 24, color: '#2196f3' }} />;
    }
    if (media.toLowerCase().includes('voz') || media.toLowerCase().includes('voice')) {
      return <VoiceChatIcon sx={{ fontSize: 24, color: '#4caf50' }} />;
    }
    return <PhoneIcon sx={{ fontSize: 24, color: '#ff9800' }} />;
  };

  const getTotalActiveQueues = () => {
    return queues.reduce((total, queue) => {
      const queueStat = queue.stats.find(s => 
        s.name.toLowerCase().includes('fila') || 
        s.name.toLowerCase().includes('aguardando')
      );
      return total + (parseInt(queueStat?.value) || 0);
    }, 0);
  };

  const totalActive = getTotalActiveQueues();

  return (
    <Box className="agent-queues-container">
      <Box className="agent-queues-header">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {getMediaIcon(media)}
          <MUITypography
            variant="h5"
            sx={{ 
              fontWeight: 700,
              color: '#333',
              fontSize: '1.3rem'
            }}
          >
            Filas de {media}
          </MUITypography>
        </Box>
        
        {totalActive > 0 && (
          <Chip
            label={`${totalActive} aguardando`}
            color={totalActive > 10 ? 'error' : totalActive > 5 ? 'warning' : 'info'}
            sx={{ 
              fontWeight: 600,
              fontSize: '0.8rem',
              '&.MuiChip-colorError': { backgroundColor: '#ffcdd2', color: '#d32f2f' },
              '&.MuiChip-colorWarning': { backgroundColor: '#ffe0b2', color: '#f57c00' },
              '&.MuiChip-colorInfo': { backgroundColor: '#bbdefb', color: '#1976d2' },
            }}
          />
        )}
      </Box>
      
      <Box className='agent-queues-list'>
        {queues.map((q, idx) => (
          <AgentQueue
            key={idx}
            name={q.name}
            notification={q.notification}
            stats={q.stats}
          />
        ))}
        
        {queues.length === 0 && (
          <Box className="no-queues-message">
            <MUITypography 
              variant="body1" 
              sx={{ 
                color: '#999',
                fontStyle: 'italic',
                textAlign: 'center',
                py: 4
              }}
            >
              Nenhuma fila de {media.toLowerCase()} ativa no momento
            </MUITypography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const AgentOverview = () => {
  const [state, setState] = useReducer(defaultReducer, {
    heartBeat: false,
    name: `${user?.first_name} ${user?.last_name}`,
    enterpriseName: enterprise?.name,
    agentStatus: user?.profile.agent?.agentstatus,
    loginTime: moment(new Date(user?.profile.agent.logints * 1000))
      .format("DD/MM HH:mm")
      .toString(),
    hasVoice: has_voice,
    userHasVoice: user_has_voice,
    extensionUser: extensionUser,
    agentUser: agentUser,
    contactData: [],
    chatQueues: [],
    voiceQueues: [],
  });

  const getData = async () => {
    const res = await api.get(
      `/api/enterprises/${enterpriseId}/agents/${agentId}/overview/`,
      { timeout: 15000 }
    );

    if (res.status === 200) {
      setState({
        name: `${user?.first_name} ${user?.last_name}`,
        enterpriseName: enterprise?.name,
        agentStatus: user?.profile.agent?.agentstatus,
        loginTime: moment(new Date(user?.profile.agent.logints * 1000))
          .format("DD/MM HH:mm")
          .toString(),
        hasVoice: has_voice,
        userHasVoice: user_has_voice,
        extensionUser: extensionUser,
        agentUser: agentUser,
        contactData: (res.data.finished_contacts || []).map(item => ({...item, label: item.name, icon: platformIcon((item?.name || '').toUpperCase())})), //res.data.finished_contacts,
        chatQueues: res.data.chat_queues,
        voiceQueues: res.data.voice_queues,
      });
    }
  };

  useEffect(async () => {
    await getData();
    clearTimeout(interval);
    interval = setTimeout(
      () => setState({ heartBeat: !state.heartBeat }),
      30000
    );
    return () => {
      clearTimeout(interval);
    };
  }, [state.heartBeat]);

  return (
    <Box id="agentoverview-body">
      {/* <Grid container spacing={2} className="agentoverview-grid"> */}
        {/* <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="agentoverview-item"
        >
          
        </Grid> */}
        <Box className='agentoverview-header'>
          <UserInfo
            name={state.name}
            agentStatus={state.agentStatus}
            enterpriseName={state.enterpriseName}
            loginTime={state.loginTime}
            agentUser={state.agentUser}
            extensionUser={state.extensionUser}
            userHasVoice={state.userHasVoice}
          />
        </Box>

        <Box className='agentoverview-positioner'>
            <Box className='agentoverview-positioner-item'>
              <Box className="chart-section-header">
                <TrendingUpIcon sx={{ fontSize: 24, color: '#2196f3', mr: 1 }} />
                <MUITypography
                  variant="h5"
                  sx={{ 
                    fontWeight: 700,
                    color: '#333',
                    fontSize: '1.3rem'
                  }}
                >
                  Atendimentos finalizados por canal
                </MUITypography>
              </Box>
              <Box className='agentoverview-positioner-dash'>
                <ContactGraph data={state.contactData} vx="name" vy="value" />
              </Box>
            </Box>
            {state.chatQueues.length > 0 &&<Box className='agentoverview-positioner-item'> <AgentQueues media="Chat" queues={state.chatQueues} /></Box>}
            {state.voiceQueues.length > 0 &&<Box className='agentoverview-positioner-item'> <AgentQueues media="Voz" queues={state.voiceQueues} /></Box>}
        </Box>
        {/* <Grid
          item
          lg={4}
          md={12}
          sm={12}
          xs={12}
          className="agentoverview-item"
        >    
        
        </Grid> */}
        {/* {state.chatQueues.length > 0 && (
          <Grid
            item
            lg={4}
            md={12}
            sm={12}
            xs={12}
            className="agentoverview-item"
          >
            <AgentQueues media="Chat" queues={state.chatQueues} />
          </Grid>
        )} */}
        {/* {state.voiceQueues.length > 0 && (
          <Grid
            item
            lg={4}
            md={12}
            sm={12}
            xs={12}
            className="agentoverview-item"
          >
            <AgentQueues media="Voz" queues={state.voiceQueues} />
          </Grid>
        )} */}
      {/* </Grid> */}
    </Box>
  );
};
export default AgentOverview;
